var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.718,
    height: 23.347,
    viewBox: "0 0 17.718 23.347",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M8.859,22.847l.879-.992q1.5-1.712,2.693-3.257l.659-.869q4.128-5.562,4.128-8.824A8.359,8.359,0,1,0,.5,8.906q0,3.262,4.128,8.824l.659.869q1.539,1.986,3.572,4.249Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_126",
    "data-name": "Ellipse 126",
    cx: 3.483,
    cy: 3.483,
    r: 3.483,
    transform: "translate(5.376 5.376)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLocationIcon);
export default __webpack_public_path__ + "static/media/footer-location-icon.3acb38a93ba2e0a6cca1568a6c439fc8.svg";
export { ForwardRef as ReactComponent };